import { type CropBox } from '../config';

export const getCroppedAspectRatio = (
  cropBox: CropBox | null,
  imageAspectRatio: number,
): number =>
  cropBox
    ? (cropBox.width / cropBox.height) * imageAspectRatio
    : imageAspectRatio;
